import { pricesAtom } from "@/modules/pricing/pricingQuery.ts";
import { getBucketPrice, sumPrices } from "@/modules/pricing/resourcePricing.ts";
import { storageAccountListQuery, type StorageAccountWithPrice } from "@/modules/storage/account/storageAccountApi.ts";
import { bucketListQueryAtom } from "@/modules/storage/bucket/bucketQuery.ts";
import { mergeLoadedQueries, type QMergedResult } from "@/utils/query/mergeQueries.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { mapOnValues } from "@warrenio/utils/collections/maps";
import { atom } from "jotai";

const storageAccountListQueryAtom = atomFromStandardQueryOptions(storageAccountListQuery);

export const storageAccountListQueryWithPricesAtom = atom(
    (get): QMergedResult<Map<string, StorageAccountWithPrice> | undefined> => {
        return mergeLoadedQueries(
            {
                accounts: get(storageAccountListQueryAtom),
                buckets: get(bucketListQueryAtom),
                prices: get(pricesAtom),
            },
            ({ accounts, buckets, prices }) =>
                mapOnValues(accounts, (account): StorageAccountWithPrice => {
                    // XXX: O(n^2) performance
                    const accountBuckets = [...buckets.values()].filter(
                        (bucket) => bucket.storage_account_uuid === account.uuid,
                    );

                    return {
                        ...account,

                        // XXX: These fields should come from the backend, possibly?
                        number_of_buckets: accountBuckets.length,
                        // Re-use the field name for `Bucket` so StorageList does not need a conditional to show it
                        size_bytes: accountBuckets.reduce((sum, bucket) => sum + bucket.size_bytes, 0),

                        price: sumPrices(accountBuckets, (bucket) => getBucketPrice(prices, bucket)),
                    };
                }),
        );
    },
);
